
import {RouterStore} from 'mobx-react-router';
import {PriceStore} from "./price/PriceStore";
import {InitStore} from "./init/InitStore";
import {CommonStore} from "./common/CommonStore";
import {CollectStore} from "./collect/CollectStore";
import {OrderStore} from "./order/OrderStore";
import {AuthorityStore} from "./setting/AuthorityStore";
import {DevStore} from './dev/DevStore';
import {AppCollectStore} from './collect/AppCollectStore';
import { AppOrderStore } from './order/AppOrderStore';
import { EcodeOrderStore } from './order/EcodeOrderStore';
import { SysStore } from './sys/sysStore';
import { AppInfoStore } from './price/AppInfoStore';
import { EcodeDemoStore } from './ecode/ecodeDemoStore';
import { HeaderStore } from './order/HeaderStore';
import EcodeGenreStore from './ecode/ecodeGenreStore';
import EcodeCollectStore from './collect/EcodeCollectStore';

const routing = new RouterStore();
const priceStore = new PriceStore(routing);
const initStore = new InitStore(routing);
const commonStore = new CommonStore(routing);
const collectStore = new CollectStore(routing);
const orderStore = new OrderStore(routing);
const authorityStore = new AuthorityStore(routing);
const devStore = new DevStore(routing);
const appCollectStore = new AppCollectStore(routing);
const appOrderStore = new AppOrderStore(routing);
const sysStore = new SysStore(routing);
const appInfoStore = new AppInfoStore(routing);
const ecodeDemoStore = new EcodeDemoStore(routing);
const ecodeOrderStore = new EcodeOrderStore(routing);
const headerStore = new HeaderStore(routing);
const ecodeGenreStore = new EcodeGenreStore(routing);
const ecodeCollectStore = new EcodeCollectStore(routing);

module.exports = {
    routing,
    initStore,
    priceStore,
    commonStore,
    collectStore,
    orderStore,
    authorityStore,
    devStore,
    appCollectStore,
    appOrderStore,
    sysStore,
    appInfoStore,
    ecodeDemoStore,
    ecodeOrderStore,
    headerStore,
    ecodeGenreStore,
    ecodeCollectStore,
};


// WEBPACK FOOTER //
// ./src/stores/index.js